let inject = ['$scope', '$uibModalInstance', 'modalOptions', 'PqrsListService', '$state'];

class PqrsFormModalController {
  constructor ($scope,$uibModalInstance, modalOptions, PqrsListService, $state) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.PqrsListService = PqrsListService;
    this.$state = $state;
    this.modalOptions = Object.assign({}, modalOptions);
    this.globals = modalOptions.globals;
    this.clientSelected = false;
    
    this.$scope.messageRestriction = '<span class="message_tool">Peso máximo por archivo <strong>3MB</strong> en formatos <strong>.jpg</strong> 0 <strong>.pdf</strong>.</span>';
    this.ext = {
      'image/jpg': 'jpg',
      'image/jpeg': 'jpg',
      // 'image/png': 'png',
      'application/pdf': 'pdf',
      // 'text/plain': 'txt',
      // 'application/msword': 'doc',
      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      // 'application/vnd.ms-excel': 'xls',
      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      // 'application/vnd.ms-powerpoint': 'ppt',
      // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
    };
    this.maxSize = 3145728;
    this.maxSizeError = false;
    this.pqrsFormData = {};
    this.pqrsFormData.attachFiles = [];
    this.pqrsFormData.files = [];
    this.pqrsParams = {};
    this.totalSize = 0;
    
    this.activate();
  }
  
  activate () {
    if (this.globals.currentClient) {
      this.clientSelected = Object.keys(this.globals.currentClient).length > 0;
      if(this.globals.currentClient.id){
        this.pqrsFormData.incidenceResponseMail = this.globals.currentClient.email;
        this.pqrsFormData.incidenceResponsePhone = this.globals.currentClient.phone;
      } else {
        this.pqrsFormData.incidenceResponseMail = this.globals.currentUser.contactEmail;
        this.pqrsFormData.incidenceResponsePhone = this.globals.currentUser.contactPhone;
      }
    }else {
      this.pqrsFormData.incidenceResponseMail = this.globals.currentUser.contactEmail;
      this.pqrsFormData.incidenceResponsePhone = this.globals.currentUser.contactPhone;
    }
    
    this.getPQRSParams();
  }
  
  copyFiles() {
    this.invalidExt = false;
    this.maxSizeError = false;
    let files = angular.copy(this.pqrsFormData.attachFiles);
    let totalSize = 0;
    
    angular.forEach(files, (value, key) => {
      totalSize += parseInt(value.filesize);
    });
    
    if ((this.totalSize + totalSize) <= this.maxSize) {
      // this.totalSize += totalSize;
      files.forEach(value => {
        if (!this.ext[value.filetype]) {
          this.invalidExt = true;
        } else {
          this.totalSize+= parseInt(value.filesize);
          this.pqrsFormData.files(value);
        }
      });
    }
    else {
      console.log('Los archivos no deben exceder 3 MB');
      this.maxSizeError = true;
    }
    this.pqrsFormData.attachFiles = [];
  }
  
  getPQRSParams() {
    this.PqrsListService.getPQRSParams().then(params => {
      this.pqrsParams = params;
    }).catch(error => {
      alert('Errror!');
    });
  }
  
  savePQRS(form) {
    this.invalidExt = false;
    this.maxSizeError = false;
    // Validate the form and trigger the invalid fields
    if(!form.$valid) {
      angular.forEach(form.$error.required, (field) => { field.$setDirty(); });
      // showPqrsErrorModal();
    }
    // Save the pqrs
    else {
      this.pqrsFormData.uploadFiles = angular.copy(this.pqrsFormData.files);
      angular.forEach(this.pqrsFormData.uploadFiles, (value, key) => {
        let fpath = value.filename.replace(/\\/g, '/');
        let fname = fpath.substring(fpath.lastIndexOf('/')+1, fpath.lastIndexOf('.'));
        this.pqrsFormData.uploadFiles[key] = {
          base64: [
            value.filetype,
            fname,
            value.filesize,
            value.base64,
          ].join(";")
        };
      });
      this.pqrsFormData.state = {};
      this.pqrsFormData.state.savingPqrs = true;
      
      let userId = this.globals.currentUser.userId;
  
      this.PqrsListService.savePQRS(userId, this.pqrsFormData).then(pqrsId => {
        this.pqrsFormData.state.savingPqrs = false;
        this.pqrsFormData.state.savedPqrs = true;
        this.pqrsId = pqrsId;
        this.pqrsFormData.attachFiles = [];
        this.pqrsFormData.files = [];
        angular.element(document.querySelector("#pqrsFile")).val(null);
        angular.forEach(form, (field, key) => {
          if (!key.startsWith('$')) {
            this.pqrsFormData[key] = '';
            form[key].$setPristine();
          }
        });
      }).catch((errors) => {
        console.log(errors);
        this.pqrsFormData.state.savingPqrs = false;
        this.pqrsFormData.state.message = errors.message;
        this.pqrsFormData.state.errors = errors.errors;
        alert(errors.message);
      });
    }
  }
  
  removeFile(file) {
    this.invalidExt = false;
    this.maxSizeError = false;
    let index = this.pqrsFormData.files.indexOf(file);
    if (index > -1) {
      this.totalSize = this.totalSize - this.pqrsFormData.files[index].filesize;
      this.pqrsFormData.files.splice(index, 1);
    }
  }
  
  goToPQRSList () {
    this.cancel();
    this.$state.go('home.pqrsList');
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.pqrsFormData.state.savedPqrs = false;
    this.$uibModalInstance.close();
  }
}

PqrsFormModalController.$inject = inject;

export default PqrsFormModalController;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-form-modal/pqrs-form-modal.controller.js
 **/